import { render, staticRenderFns } from "./s_Documents.vue?vue&type=template&id=4c3708ae&scoped=true&"
import script from "./s_Documents.vue?vue&type=script&lang=js&"
export * from "./s_Documents.vue?vue&type=script&lang=js&"
import style0 from "./s_Documents.vue?vue&type=style&index=0&id=4c3708ae&prod&lang=css&"
import style1 from "./s_Documents.vue?vue&type=style&index=1&id=4c3708ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3708ae",
  null
  
)

export default component.exports